import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { fetchNoticeList, markAllNoticeRead, markNoticeRead, type AppNotice } from '@/api/notice';

export default function NotificationsPage() {
  const [list, setList] = useState<AppNotice[]>([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    const res = await fetchNoticeList();
    if (res.code === 0 && Array.isArray(res.data)) {
      setList(res.data);
    }
    setLoading(false);
  };

  useEffect(() => {
    void load();
  }, []);

  const handleRead = async (id: number) => {
    await markNoticeRead(id);
    await load();
  };

  const handleReadAll = async () => {
    await markAllNoticeRead();
    await load();
  };

  return (
    <div className="min-h-screen flex flex-col bg-[#f7f7f8]">
      <Navbar />
      <main className="flex-1 max-w-3xl mx-auto w-full px-4 sm:px-6 py-8 pb-24 md:pb-8">
        <div className="flex items-center gap-2 text-sm text-gray-400 mb-6">
          <Link to="/account" className="hover:text-gray-700 transition-colors cursor-pointer">用户中心</Link>
          <i className="ri-arrow-right-s-line" />
          <span className="text-gray-700 font-medium">消息中心</span>
        </div>

        <div className="bg-white rounded-2xl border border-gray-100 p-6">
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-base font-semibold text-gray-800">站内通知</h2>
            <button onClick={handleReadAll} className="text-sm text-gray-500 hover:text-gray-800 transition-colors cursor-pointer">全部已读</button>
          </div>
          {loading && <div className="text-sm text-gray-400 py-8 text-center">加载中...</div>}
          {!loading && list.length === 0 && <div className="text-sm text-gray-400 py-8 text-center">暂无通知</div>}
          {!loading && list.map((n, idx) => (
            <div key={n.noticeId} className={`py-4 ${idx < list.length - 1 ? 'border-b border-gray-50' : ''}`}>
              <div className="flex items-center justify-between gap-3">
                <div className="flex items-center gap-2 min-w-0">
                  {n.readFlag === '0' && <span className="w-2 h-2 rounded-full bg-red-400 inline-block flex-shrink-0" />}
                  <span className="text-sm font-medium text-gray-800 truncate">{n.title}</span>
                </div>
                {n.readFlag === '0' && (
                  <button onClick={() => handleRead(n.noticeId)} className="text-xs text-gray-500 hover:text-gray-800">设为已读</button>
                )}
              </div>
              <p className="text-sm text-gray-500 mt-1 leading-relaxed">{n.content}</p>
              <div className="text-xs text-gray-400 mt-2">{n.createTime}</div>
            </div>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
}
